<div class="innerContainer">
	<div class="provider-status-dashboard">
		<div class="font-weight-bold grpHeader"><a (click)="groupPortalDataService.navigateToRoute('myGroup')">Group
				Info</a></div>
		<div class="divider"></div>
		<div class="widgetBodyContainer">
			<div class="program">
				<strong>{{groupList.GroupInfo?.name}}</strong>
			</div>
			<div class="row">
				<div class="col-3 infoType"><strong>Address</strong></div>
				<div class="col-9 infoData">{{groupList.GroupInfo?.street}}, {{groupList.GroupInfo?.city}},
					{{groupList.GroupInfo?.state}} {{groupList.GroupInfo?.zip}}
				</div>
			</div>
			<div class="row">
				<div class="col-3 infoType"><strong>Admin</strong></div>
				<div class="col-9 infoData">{{groupList.Administrator?.formalName }}</div>
			</div>
			<div class="row">
				<div class="col-3 infoType"><strong>Phone</strong></div>
				<div class="col-9 infoData">{{groupList.GroupInfo?.mainPhone }}</div>
			</div>
			<div class="row">
				<div class="col-3 infoType"><strong>Email</strong></div>
				<div class="col-9 infoData">{{groupList.GroupInfo?.email }}</div>
			</div>
			<div class="row icons-row">
				<div class="icon-nav px-3 pb-0">
					<a class="icon-globe" [hidden]="!groupList.GroupInfo?.webSite" title="Visit us online"
						target="_blank"
						href="{{groupList.GroupInfo?.webSite ? (groupList.GroupInfo?.webSite.substring(0, 4) == 'http' ? '' : 'https://') : ''}}{{groupList.GroupInfo?.webSite}}"></a>
					<a class="fbselect" [hidden]="!groupList.GroupInfo?.facebook" title="Visit us on Facebook"
						target="_blank"
						href="{{groupList.GroupInfo?.facebook ? (groupList.GroupInfo?.facebook.substring(0, 4) == 'http' ? '' : 'https://www.facebook.com/') : ''}}{{groupList.GroupInfo?.facebook}}"></a>
					<a class="twselect" [hidden]="!groupList.GroupInfo?.twitter" title="Visit us on Twitter"
						target="_blank"
						href="{{groupList.GroupInfo?.twitter ? (groupList.GroupInfo?.twitter.substring(0, 4) == 'http' ? '' : 'https://www.twitter.com/') : ''}}{{groupList.GroupInfo?.twitter}}"></a>
				</div>
			</div>
		</div>
	</div>
	<div class="widgetLoader {{groupInfoDoneProcessing ? 'hidethis' : ''}}"></div>
</div>


<!-- <div class="row">
			<div class="col-3"><b>Director</b></div>
			<div class="col-9">{{groupList.Director?.formalName }}</div>
		</div>
		<div class="row">
			<div class="col-3"><b>Coordinator</b></div>
			<div class="col-9">{{groupList.Coordinator?.formalName }}</div>
		</div>
		-->
<!--
		<div class="innerContainerTop">
			<div class="program">
				<strong>{{groupList.GroupInfo?.name}}</strong>
			</div>
			<div class="row">
				<div class="col-3 infoType"><b>Address</b></div>
				<div class="col-9 infoData">{{groupList.GroupInfo?.street}}, {{groupList.GroupInfo?.city}}, {{groupList.GroupInfo?.state}} {{groupList.GroupInfo?.zip}}
				</div>
			</div>
			<div class="row">
				<div class="col-3 infoType"><b>Admin</b></div>
				<div class="col-9 infoData">{{groupList.Administrator?.formalName }}</div>
			</div>
			<div class="row">
				<div class="col-3 infoType"><b>Phone</b></div>
				<div class="col-9 infoData">{{groupList.GroupInfo?.mainPhone }}</div>
			</div>
			<div class="row">
				<div class="col-3 infoType"><b>Email</b></div>
				<div class="col-9 infoData">{{groupList.GroupInfo?.email }}</div>
			</div>

			<div class="innerContainerBottomChild">
				<div class="socialOptions icon-nav">
					<a class="wwwselect" [hidden]="!groupList.GroupInfo?.webSite" title="Visit us online" target="_blank" href="{{groupList.GroupInfo?.webSite}}">www</a>
					<a class="fbselect" [hidden]="!groupList.GroupInfo?.facebook" title="Visit us on Facebook" target="_blank" href="https://facebook.com/{{groupList.GroupInfo?.facebook}}"></a>
					<a class="twselect" [hidden]="!groupList.GroupInfo?.twitter" title="Visit us on Twitter" target="_blank" href="https://twitter.com/{{groupList.GroupInfo?.twitter}}"></a>
				</div>
			</div>

		</div> -->